// extracted by mini-css-extract-plugin
module.exports = {"card-divider":"style_card-divider__WTEij"};